'use client';

import React from 'react';
import type { SelectCountryListHeaderProps } from './types';
import Header from '@pixum/header';
import { TEXT_VARIANT } from '@pixum/text';
import StarRating from '@pixum/rating';
import { scrollToElementIntoView } from 'utils';
import { REVIEW_SECTION_ID } from '../../constants';

export function SelectCountryListHeader({ headline, productReviews }: SelectCountryListHeaderProps) {
  const ratingDescription = productReviews?.ratingDescription ? `(${productReviews.ratingDescription})` : '';

  const handleClick = () => scrollToElementIntoView(REVIEW_SECTION_ID);

  return (
    <div className="select-country-list__header">
      {headline && (
        <Header headlineText={headline} headlineVariant={TEXT_VARIANT.TITLE_1} level={1} textAlignment="center" />
      )}
      {productReviews && (
        <div className="select-country-list__rating">
          <StarRating value={productReviews.rating} onClick={handleClick} description={ratingDescription} />
        </div>
      )}
    </div>
  );
}
